export type MainTab = '/dashboard' | '/profile' | '/circle' | '/oracle' | '/journey';
export function navigationOwner(path: string): MainTab | 'hidden' | null {
  const root = path.split('/')[1];
  if (['p', 's', 'go', 'premium', 'temple-test', 'signup', 'login', 'verify', 'forgot-password', 'birth-data', 'onboarding', 'avatar-forge', 'artist', 'admin'].includes(root)) return 'hidden';
  if (root === 'circle') return '/circle';
  if (root === 'oracle') return '/oracle';
  if (root === 'journey') return '/journey';
  if (['profile', 'houses', 'settings', 'terms', 'privacy', 'support', 'cookies', 'avatar-forge-commission'].includes(root)) return '/profile';
  if (path.startsWith('/reports/relationship') || path.startsWith('/reports/parenting')) return '/circle';
  if (['', 'dashboard', 'tarot', 'calendar', 'essence', 'reports'].includes(root)) return '/dashboard';
  return null;
}
